import { prop } from 'ramda';
import { useMemo } from 'react';
import { getLocationParam } from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';

export const useIsAdmin = () => {
    const isAdminLoggedIn = useAppSelector(prop('isAdminLoggedIn'));

    return useMemo(() => Boolean(isAdminLoggedIn && getLocationParam('hideAdminControls') !== '1'), [isAdminLoggedIn]);
};
